import { render } from "./thankYouComponent.vue?vue&type=template&id=b5b095f4"
import script from "./thankYouComponent.vue?vue&type=script&lang=js"
export * from "./thankYouComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__